import { ValidationKey } from '@/constants/validation-key';
import { validateCity, validateStreetName } from '@/validators/address';
import {
    CountryInstanceValidators,
    ValidationReturn
} from '@/validators/countryInstanceValidators/CountryInstanceValidators';

export class HungaryInstanceValidators implements CountryInstanceValidators {
    validateBankAccountNumber(accountNumber: string): ValidationReturn {
        const normalized = accountNumber.replace(/[\s-]/g, '');
        const isValid = /^\d{12}$|^\d{24}$/.test(normalized);
        return !isValid ? ValidationKey.BankAccountNumber : undefined;
    }

    validatePhoneNumber(phoneNumber: string): ValidationReturn {
        const pattern = new RegExp(/^(\d( *)){8,12}$/, 'g');
        const isValid = pattern.test(phoneNumber);
        return !isValid ? ValidationKey.InvalidPhone : undefined;
    }

    validatePhoneNumberWithPrefix(phoneNumber: string): ValidationReturn {
        const pattern = new RegExp(/^(\+36)( )*(\d( *)){8,12}$/, 'g');
        const isValid = pattern.test(phoneNumber);
        return !isValid ? ValidationKey.InvalidPhone : undefined;
    }

    validateTaxIdentificationNumber(taxNumber: string): ValidationReturn {
        const isValid = /^\d{8}-\d-\d{2}$/.test(taxNumber);
        return !isValid ? ValidationKey.InvalidTaxNumber : undefined;
    }

    validateInternationalTaxIdentificationNumber(taxNumber?: string): ValidationReturn {
        if (!taxNumber) {
            return undefined;
        }
        const isValid = /^([hH][uU])\d{8}$/.test(taxNumber);
        return !isValid ? ValidationKey.InvalidInternationalTaxNumber : undefined;
    }

    validateZipCode(zipCode: string): ValidationReturn {
        const pattern = new RegExp(/^\d{4}$/, 'g');
        const isValid = pattern.test(zipCode);
        return !isValid ? ValidationKey.InvalidZipCode : undefined;
    }

    validateCity(city: string, minLength = 2): ValidationReturn {
        return validateCity(city, minLength);
    }

    validateStreet(street: string, minLength = 2): ValidationReturn {
        return validateStreetName(street, minLength);
    }

    validateBuildingNo(buildingNo: string): ValidationReturn {
        if (buildingNo.startsWith('0')) {
            return ValidationKey.BuildingNoCannotStartsWithZero;
        }
        const VALID_BUILDING_NO_REGEXP = /^[1-9\s/]{0,25}[a-zA-Z]{0,1}[0-9\s/]{0,25}$/;
        const isValid = VALID_BUILDING_NO_REGEXP.test(buildingNo);

        return !isValid ? ValidationKey.BuildingNo : undefined;
    }
}
